import request from './request'

export const login = (data) => {
  return request({
    url: '/admin/login',
    method: 'post',
    data
  })
}

export const logout = () => {
  return request({
    url: '/admin/logout',
    method: 'post'
  })
}
